import React from "react";
import CoursetypeList from "../CourseType/List";

export default function TagsList() {
  return <CoursetypeList defaultTab="tags" />;
}
